import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('conversations-calling-message', {
  library: 'conversations-calling-message'
});